<template>
  <FocusLoop class="popup-block" @click="closePopup($event)" ref="close-popu" role="dialog" aria-modal="true" :isVisible="true">
    <div class="preview-block" role="presentation">
      <button @click="closePopup($event)" class='btn-close' aria-label="Close popup view"></button>
      <button v-if="isNextImage_360" @click="setNewPreviewObj(swiper.activeIndex + 1)" class='arrow next main-background' aria-label="Next image"></button>
      <button v-if="isPrevImage_360" @click="setNewPreviewObj(0)" class='arrow prev main-background' aria-label="Previous image"></button>
      <div v-if="isReadyIsImage" class="custom-zoom" role="presentation">
        <div class="button-container" role="presentation">
          <button @click="zoomIn()" class='zoom-in' aria-label="Zoom in"></button>
          <button @click="zoomOut()" class='zoom-out' aria-label="Zoom out"></button>
        </div>
      </div>
      <swiper :options="swiperOption" @slideChange='changedSlide()' class="preview" ref="mySwiper">
        <swiper-slide v-for="(item) in list" :key="item.id">
          <div v-if="item.type === 'image'" class='swiper-zoom-container' :data-swiper-zoom="currentZoom" role="presentation">
            <img class='img-preview' :src="item.file.url" crossorigin="anonymous" alt="">
            <p v-if="item.type === 'image' && item.settings.description" class='image-description'>{{ item.settings.description }}</p>
          </div>
          <div class='video-player-container' v-else-if="item.type === 'video'" role="presentation">
            <vue-video-player :class='{ "transcript-active": transcript }' class="video-player "
              ref="videoPlayer"
              crossOrigin="anonymous"
              :options="{
                muted: muted,
                responsive: true,
                controls: true,
                sources: [{
                  type: 'video/mp4',
                  src: item.job.outputs.length > 0 ? item.job.outputs[0].resultUrl : ''
                }]}"
              :playsinline="true"
              @ready="onPlayerReady"
              />
            <div v-if="transcript" class="video-transcript">
              <h4 class='main-color'>Transcript</h4>
              <div v-html="$tr(transcript)"></div>
            </div>
          </div>
          <panorama v-else-if="item.type === 'image_360'" :source="item.file.url" :settings="item.settings" />
          <iframe v-else-if="item.type === '3d_link'" allowfullscreen :src="item.settings.url" frameborder="0"></iframe>
        </swiper-slide>
      </swiper>
      <div class="scroll-hidder" v-if="isShowlistSwiper" role="presentation">
        <ul :style="{ 'margin-left': previewMargin }" role="menu">
          <li v-for="(item, idx) in list"
              :key="item.id"
              :class="{ 'active': swiper.activeIndex === idx }"
              :style="{ 'borderColor': 'white' }"
              @click.stop="setNewPreviewObj(idx)"
              @keypress.stop="setNewPreviewObj(idx)"
              role="menuitem"
              tabindex="0">
            <img :src="item.file ? item.file.url : require('@/assets/placeholder-video.png')" crossorigin="anonymous" alt="">
          </li>
        </ul>
      </div>
    </div>
  </FocusLoop>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import { FocusLoop } from '@vue-a11y/focus-loop'

export default {
  name: 'PopupView',
  components: {
    'panorama': () => import(/* webpackChunkName: "panorama" */ './PoiPano'),
    // 'vue-video-player': () => import(/* webpackChunkName: "videojs" */ 'vue-video-player').then((res) => res.videoPlayer)
    'vue-video-player': videoPlayer,
    FocusLoop
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    transcript: {
      type: Object,
      default: undefined
    },
    videoCC: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isReadyIsImage: false,
      isNextImage_360: false,
      isPrevImage_360: false,
      currentZoom: 2,
      isShowlistSwiper: false,
      currentMaxRatio: 5,
      swiperOption: {
        zoom: {
          minRatio: 1,
          toggle: false
        },
        spaceBetween: 20
      },
      previewMargin: 'auto'
    }
  },
  beforeMount () {
    window.addEventListener('resize', this.calcPreviewMargin, true)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcPreviewMargin, true)
  },
  computed: {
    muted: function () {
      if (this.$store.state.college.settings.video_settings === undefined ||
          this.$store.state.college.settings.video_settings.muted === undefined) {
        return true
      } else {
        return this.$store.state.college.settings.video_settings.muted
      }
    },
    mainColor: function () {
      return this.$store.state.college.settings['main_color']
    },
    swiper: function () {
      return this.$refs.mySwiper.swiper
    },
    player: function () {
      return this.$refs.videoPlayer[0].player
    }
  },
  mounted () {
    this.isShowlistSwiper = true
    this.isReadyIsImage = this.list[this.index].type === 'image'
    this.isNextImage_360 = (this.list[this.swiper.activeIndex].type === 'image_360' || this.list[this.swiper.activeIndex].type === '3d_link') && this.swiper.activeIndex < this.list.length - 1
    this.isPrevImage_360 = (this.list[this.swiper.activeIndex].type === 'image_360' || this.list[this.swiper.activeIndex].type === '3d_link') && this.swiper.activeIndex !== 0
    this.swiper.slideTo(this.index, 1000, false)
    // this.swiper.zoom.disable()
    this.checkSwipeAvailable()
  },
  methods: {
    onPlayerReady: function () {
      if (this.videoCC.length > 0) {
        this.videoCC.forEach(item => {
          this.player.addRemoteTextTrack({
            src: item.file.url,
            kind: 'captions',
            srclang: this.$consts.languages[item.settings.language] || 'en',
            label: item.settings.language || 'English' }, true)
        })
        this.player.remoteTextTracks()[0].mode = 'showing'
      }
    },
    calcPreviewMargin: function () {
      if (this.swiper && window.innerWidth < (this.swiper.slides.length * 100)) {
        const slidePosition = (window.innerWidth - 100) / 2
        const neededMargin = this.swiper.activeIndex * 110

        this.previewMargin = `${slidePosition - neededMargin}px`
      } else {
        this.previewMargin = 'auto'
      }
    },
    zoomIn: function () {
      if (this.currentMaxRatio === this.currentZoom) return
      this.currentZoom += 1

      // Needed to properly reset current slide for zoom buttons
      this.swiper.clickedSlide = undefined

      this.swiper.zoom.in()
    },
    zoomOut: function () {
      this.currentZoom = 2

      // Needed to properly reset current slide for zoom buttons
      this.swiper.clickedSlide = undefined

      this.swiper.zoom.out()
    },
    checkSwipeAvailable: function () {
      if (this.list[this.swiper.activeIndex].type === 'image_360') {
        this.swiper.allowTouchMove = false
      } else {
        this.swiper.allowTouchMove = true
      }
    },
    changedSlide: function () {
      this.checkSwipeAvailable()
      this.calcPreviewMargin()
      this.zoomOut()
      this.isReadyIsImage = this.list[this.swiper.activeIndex].type === 'image'
      this.isNextImage_360 = (this.list[this.swiper.activeIndex].type === 'image_360' || this.list[this.swiper.activeIndex].type === '3d_link') && this.swiper.activeIndex < this.list.length - 1
      this.isPrevImage_360 = (this.list[this.swiper.activeIndex].type === 'image_360' || this.list[this.swiper.activeIndex].type === '3d_link') && this.swiper.activeIndex !== 0
    },
    setNewPreviewObj: function (index) {
      this.swiper.slideTo(index, 300, false)
      this.zoomOut()
      this.calcPreviewMargin()
    },
    closePopup: function (event) {
      if (event.target.classList.contains('swiper-slide') ||
          event.target.classList.contains('scroll-hidder') ||
          event.target.classList.contains('btn-close')) {
        this.$emit('close-popup', false)
      } else {
        event.stopPropagation()
      }
    }
  }
}
</script>
